class MissionSendToHospitalInfo {
  constructor(
    address,
    rank,
    rankText,
    ambulanceCode,
    chiefComplaint,
    admission,
    shabrang,
    codeStatus,
    phoneNumber,
  ) {
    this.address = address;
    this.rank = rank;
    this.rankText = rankText;
    this.ambulanceCode = ambulanceCode;
    this.chiefComplaint = chiefComplaint;
    this.admission = admission;
    this.shabrang = shabrang;
    this.codeStatus = codeStatus;
    this.phoneNumber = phoneNumber;
  }
}
export default {
  MissionSendToHospitalInfo,
};
